module.exports = __webpack_public_path__ + "static/coinImage-3b042de61c6a2462d9b88e6f9557f560.png";